import React, {Component} from 'react';
import {Modal, Tabs} from 'antd';
import './TabModal.css';

const { TabPane } = Tabs;
class TabModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            visible: props.visible,
            confirmLoading: false,
            activeIndex: this.props.activeIndex,
            tabPanels:this.props.tabPanels
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visible: nextProps.visible,
            activeIndex: nextProps.activeIndex,
            tabPanels:nextProps.tabPanels
        })
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = () => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = () => {
        this.props.onCancel();
        this.setState({
            visible: false,
        });
    };

    render() {
        const { visible, confirmLoading } = this.state;
        if(!this.props.tabs || this.props.tabs.length === 0){
            return <div></div>
        }
        return (
            <Modal
                wrapClassName={"tabModal"}
                title={<Tabs type="card" size={"small"}
                             onTabClick={(key, e)=>{
                                 this.props.activeIndexChange(parseInt(key));
                                 this.setState({
                                     activeIndex: parseInt(key)
                                 })
                             }}
                             activeKey={this.state.activeIndex + "_key"}
                >
                    {this.props.tabs && this.props.tabs.map((tab, index) => {
                        return <TabPane tab={tab.title} key={index + "_key"}/>
                    })}
                </Tabs>}
                visible={visible}
                onOk={this.handleOk}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={this.props.width}
                bodyStyle={{padding:"0px"}}
                zIndex={500}
                footer={this.props.tabs?this.props.tabs[this.state.activeIndex].footer:null}
                style={{padding:"16px 24px 0 24px"}}
            >
                {this.props.tabPanels[this.state.activeIndex]}
            </Modal>
        );
    }
}
TabModal.defaultProps = {
    activeIndex: 0,
    activeIndexChange:()=>{},
    width:800,
    onCancel:()=>{},
    tabs:["基本信息","拟发平台","分派记者","任务稿件","任务图片","任务视频","美工附件"],
    tabPanels:[<div>基本信息</div>,"拟发平台","分派记者","任务稿件","任务图片","任务视频","美工附件"],
};
export default TabModal;